export default __webpack_public_path__ + "static/media/conLogo.82565d1e.png";